module.exports = __webpack_public_path__ + "static/media/sparkBranding.f693f0d9.jpg";